import { render, staticRenderFns } from "./GSRPPickPrograms.vue?vue&type=template&id=2ec88517&scoped=true&"
import script from "./GSRPPickPrograms.vue?vue&type=script&lang=ts&"
export * from "./GSRPPickPrograms.vue?vue&type=script&lang=ts&"
import style0 from "./GSRPPickPrograms.vue?vue&type=style&index=0&id=2ec88517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec88517",
  null
  
)

export default component.exports